import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/.netlify/functions' 
  : 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiService = {
  // Get all reviews with optional filters
  getReviews: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.type) params.append('type', filters.type);
    if (filters.tags) params.append('tags', filters.tags);
    if (filters.sort) params.append('sort', filters.sort);
    if (filters.order) params.append('order', filters.order);
    
    const endpoint = process.env.NODE_ENV === 'production' ? '/reviews' : '/reviews';
    console.log('🌐 API Call:', `${API_BASE_URL}${endpoint}?${params.toString()}`);
    
    const response = await api.get(`${endpoint}?${params.toString()}`);
    console.log('📦 API Response:', response.data);
    
    return response.data;
  },

  // Get single review
  getReview: async (id) => {
    const response = await api.get(`/reviews/${id}`);
    return response.data;
  },

  // Create new review
  createReview: async (reviewData) => {
    const endpoint = process.env.NODE_ENV === 'production' ? '/reviews' : '/reviews';
    const response = await api.post(endpoint, reviewData);
    return response.data;
  },

  // Update review
  updateReview: async (id, reviewData) => {
    const endpoint = process.env.NODE_ENV === 'production' 
      ? `/reviews?id=${id}` 
      : `/reviews/${id}`;
    console.log('🔄 Updating review:', id, reviewData);
    const response = await api.put(endpoint, reviewData);
    return response.data;
  },

  // Delete review
  deleteReview: async (id) => {
    const endpoint = process.env.NODE_ENV === 'production' 
      ? `/reviews?id=${id}` 
      : `/reviews/${id}`;
    console.log('🗑️ Deleting review:', id);
    const response = await api.delete(endpoint);
    return response.data;
  },
};

export default apiService;
